import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {GetTimeLineResponse} from '../../api/types/reportingApi.type';

export interface TimelineIngestionType {
  sourceName: string;
  sourceType: string;
  source: {
    id: string;
    name: string;
  };
  navigationSourceType: string;
}

interface TimelineState {
  selectedIngestion: TimelineIngestionType | null;
  leftPanelData: Record<string, any> | null;
  timelineResult: Record<string, any> | null;
  appliedFilters: Record<string, any> | null;
  reportConfig: any | null;
  generatedReportData: GetTimeLineResponse | null;
}

const initialState: TimelineState = {
  selectedIngestion: null,
  leftPanelData: null,
  timelineResult: null,
  appliedFilters: null,
  reportConfig: null,
  generatedReportData: null,
};

const timelineGapReportSlice = createSlice({
  name: 'timelineGapReport',
  initialState,
  reducers: {
    setTimelineIngestion: (
      state,
      action: PayloadAction<TimelineIngestionType>
    ) => {
      state.selectedIngestion = action.payload;
    },
    clearTimelineIngestion: (state) => {
      state.selectedIngestion = null;
    },
    setLeftPanelData: (state, action: PayloadAction<Record<string, any>>) => {
      state.leftPanelData = action.payload;
    },
    setTimelineResult: (state, action: PayloadAction<Record<string, any>>) => {
      state.timelineResult = action.payload;
    },
    setAppliedFilters: (state, action: PayloadAction<Record<string, any>>) => {
      state.appliedFilters = action.payload;
    },
    setTimelineConfig: (state, action: PayloadAction<any>) => {
      state.reportConfig = action.payload;
    },
    setGeneratedReportData: (
      state,
      action: PayloadAction<GetTimeLineResponse>
    ) => {
      state.generatedReportData = action.payload;
    },
    clearAllTimelineData: (state) => {
      state.selectedIngestion = null;
      state.timelineResult = null;
      state.appliedFilters = null;
      state.reportConfig = null;
      state.generatedReportData = null;
    },
  },
});

export const {
  setTimelineIngestion,
  clearTimelineIngestion,
  setLeftPanelData,
  setTimelineResult,
  setAppliedFilters,
  setTimelineConfig,
  setGeneratedReportData,
  clearAllTimelineData,
} = timelineGapReportSlice.actions;
export default timelineGapReportSlice.reducer;
